import React, { Component } from "react"
import styled from "styled-components"
import Resources from "../../resources/mlp-resources.json"
import SpecialityAreaItem from "./area-item"
import Fade from "react-reveal/Fade"
import { useSiteContent } from "../hooks/use-site-content"

const AreaConf = Resources.areas_esp

const SpecialtyAreaSection = styled.section`
  background-color: #f3f3f3;
  padding: 40px 0;
`

const SpecialityAreaWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2em;
  margin-top: 40px;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr;
  }
`

const SpecialityAreaTitle = styled.label`
  font-family: var(${AreaConf.title.font});
  color: var(${AreaConf.title.color});
  font-size: ${AreaConf.title.size};
  text-transform: uppercase;
`

class SpecialityArea extends Component {
  render() {
    return (
      <SpecialtyAreaSection>
        <div className="container" id="specialty-areas">
          <Fade up>
            <SpecialityAreaTitle>{AreaConf.title.label}</SpecialityAreaTitle>
            <SpecialityAreaWrapper>
              <SpecialityAreaItem type="administration" />
              <SpecialityAreaItem type="debt" />
              <SpecialityAreaItem type="borrow" />
              <SpecialityAreaItem type="money" />
            </SpecialityAreaWrapper>
          </Fade>
        </div>
      </SpecialtyAreaSection>
    )
  }
}

export default props => {
  const SiteContent = useSiteContent()
  return <SpecialityArea siteContent={SiteContent} {...props} />
}
